import { JoinSacRequest } from 'domain/usecases/sacRequest/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteJoinSacRequest implements JoinSacRequest {
  private readonly url: string;

  private readonly httpClient: HttpClient<JoinSacRequest.Model>;

  constructor(url: string, httClient: HttpClient<JoinSacRequest.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  join = async (
    params: JoinSacRequest.Params,
  ): Promise<JoinSacRequest.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{request}', params.request.toString()),
      method: 'post',
      headers: params?.token
        ? {
            Authorization: `APIKEY ${params?.token}`,
          }
        : undefined,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
